import React from 'react';
import { useTranslation } from 'react-i18next';
import { TDR } from 'tdr-common';
import { AssignedSeatingCard } from '../../inventory-carousel/AssignedSeatingCard';
import { Skeleton } from '../../skeleton/Skeleton';

export type StandardSeatingSectionProps = {
	section: TDR.SearchConfig.StandardSeatingSection;
	restaurant: TDR.Restaurant;
	showSkeleton: boolean;
};

export function StandardSeatingSection({ section, restaurant, showSkeleton }: StandardSeatingSectionProps) {
	const { t } = useTranslation();

	if (!restaurant.settings?.alternativePlatform) {
		return null;
	}

	return (
		<section className='px-5 pt-6 pb-2 sm:px-0 sm:pt-4'>
			<h2 className='font-poppins text-tablz-text-gray-2 text-lg font-medium mb-3'>{t('inventory.standard_seating')}</h2>
			{showSkeleton ? (
				<Skeleton height='140px' width='100%' />
			) : (
				<AssignedSeatingCard restaurant={restaurant} header={section.header} body={section.body} />
			)}
		</section>
	);
}
